import logo from '../../assets/img/logo.png';
import yourTv from '../../assets/img/your-tv.svg';
import downloadOffline from '../../assets/img/download-offline.svg';
import WatchEverywhere from '../../assets/img/Watch-everywhere.svg';
import createProfilesKids from '../../assets/img/create-profiles-kids.svg';
import LoginFooter from '../../Component/Footer';
import { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useDispatch, useSelector } from 'react-redux';
import List from '../../Component/List';
import { GET_TRENDING_REQUEST } from '../../redux/types';
import { GET_INITIAL_API_SUCCESS } from '../../redux/types';
const SignUpNew = () => {

    const faqData = [
        { name: "What is Darkroom?", conts: "Darkroom is a streaming service that offers a wide variety of award-winning TV shows, movies, anime, documentaries and more – on thousands of internet-connected devices." },
        { name: "How much does Darkroom cost?", conts: "Watch Darkroom on your smartphone, tablet, Smart TV, laptop, or streaming device, all for one fixed monthly fee. Plans range from ₹149 to ₹649 a month. No extra costs, no contracts." },
        { name: "Where can I watch?", conts: "Watch anywhere, anytime. Sign in with your Darkroom account to watch instantly on the web at Darkroom.com from your personal computer or on any internet-connected device that offers the Darkroom app, including smart TVs, smartphones, tablets, streaming media players and game consoles." },
        { name: "How do I cancel?", conts: "Darkroom is flexible. There are no annoying contracts and no commitments. You can easily cancel your account online in two clicks. There are no cancellation fees – start or stop your account anytime." },
        { name: "What can I watch on Darkroom?", conts: "Darkroom has an extensive library of feature films, documentaries, TV shows, anime, award-winning Darkroom originals, and more. Watch as much as you want, anytime you want." },
        { name: "Is Darkroom good for kids?", conts: "The Darkroom Kids experience is included in your membership to give parents control while kids enjoy family-friendly TV shows and films in their own space." }
    ];
    const [faqActive, setFaqShowHide] = useState<number | null>(null); // Use null for no active FAQ
    const showhFaq = (item: number | null) => {
        setFaqShowHide(item);
    };
    const [username, setUsername] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [step, setStep] = useState(1); // 1: username/email, 2: password, 3: verify/log
    // Only one useState for emailError and setEmailError
    const [emailError, setEmailError] = useState(false);
    const [usernameError, setUsernameError] = useState(false);
    const [passwordError, setPasswordError] = useState(false);

    const dispatch = useDispatch();
    useEffect(() => {
        // Force dev_base_url to production
        dispatch({ type: GET_INITIAL_API_SUCCESS, response: { dev_base_url: 'https://www.darkroom.film/backend/api/v3' } });
        dispatch({ type: GET_TRENDING_REQUEST, userId: '', range: 0 });
    }, [dispatch]);
    const trendingData = useSelector((state: any) => state.homeReducer?.trendingData?.data || []);

    // Handlers for each step
    const handleFirstStep = (event: any) => {
        event.preventDefault();
        const usernameVal = event.target.UserName ? event.target.UserName.value.trim() : '';
        const emailVal = event.target.email ? event.target.email.value.trim() : '';
        let valid = true;
        setUsernameError(false);
        setEmailError(false);
        if (!usernameVal) {
            setUsernameError(true);
            valid = false;
        }
        if (!emailVal || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(emailVal)) {
            setEmailError(true);
            valid = false;
        }
        if (valid) {
            setUsername(usernameVal);
            setEmail(emailVal);
            setStep(2);
        }
    };

    const handleSecondStep = async (event: any) => {
        event.preventDefault();
        const passwordVal = event.target.password ? event.target.password.value : '';
        setPasswordError(false);
        if (!passwordVal) {
            setPasswordError(true);
            return;
        }
        setPassword(passwordVal);
        // Log all three fields after password step as well
        console.log({ username, email, password: passwordVal });
        // API call (now sign-up-new)
        try {
            const response = await axios.post('https://www.darkroom.film/backend/api/v3/sign-up-new', {
                username: username,
                email: email,
                password: passwordVal,
                confirm_password: passwordVal,
                signup_type: 1
            }, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            console.log('API response:', response.data);
            toast(response.data.message);
            if (response.data.status_code !== 2) {
                setStep(3);
            }
            // If status_code is 2, do not proceed (user already exists)
        } catch (error) {
            console.error('API error:', error);
            toast('An error occurred. Please try again.');
        }
    };

    // In step 3, handle OTP form submit and log all fields
    const handleOtpStep = async (event: any) => {
        event.preventDefault();
        // Collect OTP values from the form
        const form = event.target;
        const otpCode = [form.otp1.value, form.otp2.value, form.otp3.value, form.otp4.value].join('');
        if (otpCode.length !== 4) {
            toast('Please enter the 4-digit OTP code.');
            return;
        }
        try {
            const response = await axios.post('https://www.darkroom.film/backend/api/v3/account-verification-with-otp', {
                username: username,
                email: email,
                password: password,
                confirm_password: password,
                mail_type: 'NEW-REGISTRATION',
                opt: otpCode
            });
            console.log('OTP API response:', response.data);
            toast(response.data.message);
        } catch (error) {
            console.error('OTP API error:', error);
            toast('An error occurred during OTP verification.');
        }
    };

    // No-op handlers for List props
    const toggleWishlist = () => {};
    const toggleRemoveWishlist = () => {};
    const setLoginAlertBool = () => {};
    const advancedSearchClick = () => {};

    return (<>
        <div className="loginrgstr-page">
            <div className="login_main">
                <div className='login-header'>
                    <div className='container'>
                        <div className='login-main'>
                            <div className="login-logo text-center">
                                <a href="/"> <img src={logo} alt="" /></a>
                            </div>
                            <div className='loginheader-right'>
                                <a className='btn login-btn' href='/SignupNew'>Sign in</a>
                            </div>
                        </div>
                    </div>
                </div>
                <section className='loginrgstrform-section'>
                    <div className='loginrgstr-maincover'>
                        <div className='container'>
                            <div className='loginrgstr-main'>
                                <div className='loginrgstrhead-text text-center text-white'>
                                    {(step === 1 || step === 2) && <h1>Unlimited movies, TV shows and more</h1>}
                                    {(step === 1 || step === 2) && <p>Starts at <strong>$1.99</strong> monthly. Cancel at any time.</p>}
                                    {step === 3 && <h1>Great, now let us<br></br> verify your email</h1>}
                                    {step === 3 && <p>Click the link we sent to <strong>{email}</strong> to Verify.</p>}
                                </div>
                                <div className='loginrgstr-formcover justify-content-center text-center'>
                                    {(step === 1 || step === 2) && <h3 className='text-white py-3'>Ready to watch? Enter your email to
                                        create or restart your membership.</h3>}
                                    {step === 3 && <h3 className='text-white py-3'>Verifying your email will improve account security and help
                                        you receive important Darkroom communications.</h3>}
                                    {/* Step 1: Username and Email */}
                                    {step === 1 && (
                                        <form onSubmit={handleFirstStep} className="loginrgstr-form justify-content-center">
                                            <div className="form-grid">
                                                <div className="form-group">
                                                    <div className='formsign-insidepanel w-100'>
                                                        <input type="text" placeholder="User Name" name="UserName" className="form-control" />
                                                        {usernameError && <p className='text-danger text-left'><strong>X</strong><span>Please fill in a valid User Name</span></p>}
                                                    </div>
                                                    <div className='formsign-insidepanel w-100'>
                                                        <input type="email" placeholder="Email  Address" name="email" className="form-control" />
                                                        {emailError && <p className='text-danger text-left'><strong>X</strong><span>Please fill in a valid Email Address</span></p>}
                                                    </div>
                                                </div>
                                                <div className="form-group justify-content-center">
                                                    <button type="submit" className="btn mt-3 w-100 justify-content-center">
                                                        <span>Get Started</span>
                                                        <i className='fa fa-angle-right'></i>
                                                    </button>
                                                </div>
                                            </div>
                                        </form>
                                    )}
                                    {/* Step 2: Password */}
                                    {step === 2 && (
                                        <form onSubmit={handleSecondStep} className="loginrgstr-form justify-content-center">
                                            <div className="form-grid">
                                                <div className="form-group">
                                                    <input type="password" placeholder="Enter your password" name="password" className="form-control" />
                                                    <button type="submit" className="btn">
                                                        <span>Next</span>
                                                        <i className='fa fa-angle-right pl-2'></i>
                                                    </button>
                                                </div>
                                                {passwordError && <p className='text-danger text-left'><strong>X</strong><span>Please fill in a valid Password</span></p>}
                                                <div className='linkforgot-passtext pt-2 text-left'>
                                                    <a className="linkforgot-password" href="#">Forgot your password?</a>
                                                </div>
                                            </div>
                                        </form>
                                    )}
                                    {/* Step 3: Final step, keep OTP fields and 'Verify' button, but log fields on submit */}
                                    {step === 3 && (
                                        <form onSubmit={handleOtpStep} className="loginrgstr-form justify-content-center">
                                            <div className="form-grid">
                                                <div className="form-group">
                                                    <div className='carifycodeinpt-grid'>
                                                        <input type="tel" maxLength={1} name="otp1" className="form-control" />
                                                        <input type="tel" maxLength={1} name="otp2" className="form-control" />
                                                        <input type="tel" maxLength={1} name="otp3" className="form-control" />
                                                        <input type="tel" maxLength={1} name="otp4" className="form-control" />
                                                    </div>
                                                    <button type="submit" className="btn">
                                                        <span>Verify</span>
                                                        <i className='fa fa-angle-right pl-2'></i>
                                                    </button>
                                                </div>
                                            </div>
                                        </form>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className='loginrgstr-trendingsection'>
                    <div className='container'>
                        <div className='loginrgstr-trendingsmain'>
                            <div className="title"><span><i>
                                <img src="https://www.darkroom.film/backend/public/uploads/admin/icon/202302181603_Trending.png" /></i> Trending</span>
                                <a className="viewall" href="/category?category_id=63&amp;category_name=Trending&amp;type=genre&amp;genre_type=3">View All Trending</a>
                            </div>
                            {/* Render trending list using List component */}
                            <div>
                                {trendingData && trendingData.length > 0 ? (
                                    trendingData.map((item: any, index: number) => (
                                        <List
                                            key={item.id || index}
                                            item={item}
                                            index={index}
                                            toggleWishlist={toggleWishlist}
                                            toggleRemoveWishlist={toggleRemoveWishlist}
                                            setLoginAlertBool={setLoginAlertBool}
                                            advancedSearchClick={advancedSearchClick}
                                        />
                                    ))
                                ) : (
                                    <div>No trending data available.</div>
                                )}
                            </div>
                        </div>
                    </div>
                </section>
                <section className='morereasons-section'>
                    <div className='container'>
                        <div className='morereasons-main'>
                            <div className="title">
                                <span><i><img src="https://www.darkroom.film/backend/public/uploads/admin/icon/202308281843_TopPicks.png" /></i>
                                    More reasons to join
                                </span>
                            </div>
                        </div>
                        <div className='morereasons-cardgrid'>
                            <div className='morereasons-cardgroup'>
                                <div className='morereasons-cardpanel'>
                                    <h3>Enjoy on your TV</h3>
                                    <p>Watch on smart TVs, PlayStation, Xbox, Chromecast, Apple TV, Blu-ray players and more.</p>
                                    <div className="morereasons-icon">
                                        <img src={yourTv} />
                                    </div>
                                </div>
                            </div>
                            <div className='morereasons-cardgroup'>
                                <div className='morereasons-cardpanel'>
                                    <h3>Download your shows to watch offline</h3>
                                    <p>Save your favourites easily and always have something to watch.</p>
                                    <div className="morereasons-icon">
                                        <img src={downloadOffline} />
                                    </div>
                                </div>
                            </div>
                            <div className='morereasons-cardgroup'>
                                <div className='morereasons-cardpanel'>
                                    <h3>Watch everywhere</h3>
                                    <p>Stream unlimited movies and TV shows on your phone, tablet, laptop and TV.</p>
                                    <div className="morereasons-icon">
                                        <img src={WatchEverywhere} />
                                    </div>
                                </div>
                            </div>
                            <div className='morereasons-cardgroup'>
                                <div className='morereasons-cardpanel'>
                                    <h3>WatchEverywhere</h3>
                                    <p>Send kids on adventures with their favourite characters in a space made just for them — free with your membership.</p>
                                    <div className="morereasons-icon">
                                        <img src={createProfilesKids} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className='loginrgstrfaq-section'>
                    <div className='container'>
                        <div className='loginrgstrfaq-main'>
                            <div className="title">
                                <span>Frequently Asked Questions</span>
                            </div>
                        </div>
                        <div className='loginrgstrfaq-cardgrid'>
                            {faqData.map((faq, index) => (
                                <div
                                    key={index}
                                    onClick={() => showhFaq(faqActive === index ? null : index)}
                                    className={faqActive === index ? 'loginrgstrfaq-headgroup active' : 'loginrgstrfaq-headgroup'}
                                >
                                    <div className='loginrgstrfaq-headpanel'>
                                        <h3>{faq.name}</h3>
                                        <span>
                                            <i className={faqActive === index ? 'fa fa-minus' : 'fa fa-plus'}></i>
                                        </span>
                                    </div>
                                    {faqActive === index && (
                                        <div className='loginrgstrfaq-body'>
                                            <p>{faq.conts}</p>
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                <LoginFooter />
            </div>
        </div>
    </>)
}

export default SignUpNew;